/**
 * Convierte los segundos que envía el histórico de monitoreo a un texto legible.
 * El back siempre manda duraciones en segundos (campos terminados en _seg).
 */
export function formatSecondsDuration(seconds: number | null | undefined): string {
  if (!seconds || seconds <= 0) return '0h 00m';

  const totalMinutes = Math.floor(seconds / 60);
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  return `${hours}h ${minutes.toString().padStart(2, '0')}m`;
}
